import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

// Full, comprehensive map: { 'AE': 'ARE', 'CH': 'CHE', ... }
export const ISO2_TO_ISO3 = countries.getAlpha2Codes(); // returns alpha-2 -> alpha-3 map  [oai_citation:0‡npmdoc.github.io](https://npmdoc.github.io/node-npmdoc-i18n-iso-countries/build/apidoc.html)

export const ISO3_TO_ISO2 = Object.entries(ISO2_TO_ISO3 || {}).reduce((acc, [iso2, iso3]) => {
  if (iso2 && iso3) acc[String(iso3).toUpperCase()] = String(iso2).toUpperCase();
  return acc;
}, {});

export const COUNTRY_ALIAS_TO_ISO2 = {
  uae: "AE",
  uk: "GB",
  bvi: "VG",
  usa: "US",
  us: "US",
  "united states america": "US",
  "united states of america": "US",
};

export function normalizeCountryLookupName(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’‘`]/g, "'")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
}

export function resolveCountryAliasToIso2(value) {
  return COUNTRY_ALIAS_TO_ISO2[normalizeCountryLookupName(value)] || "";
}

export function countryNameKeysForIso3(iso3) {
  const key = String(iso3 || "").trim().toUpperCase();
  if (!key) return [];

  const iso2 = ISO3_TO_ISO2[key] || "";
  const names = new Set();

  [key, iso2].filter(Boolean).forEach((code) => {
    const name = countries.getName(code, "en");
    if (name) names.add(normalizeCountryLookupName(name));
  });

  return Array.from(names);
}

export function toIso3(code) {
  const v = String(code || "")
    .trim()
    .toUpperCase();
  if (!v) return "";
  if (v.length === 3) return v; // already ISO3
  if (v.length === 2) return ISO2_TO_ISO3[v] || "";
  return "";
}

const COUNTRY_ALIASES_BY_ISO2 = Object.entries(COUNTRY_ALIAS_TO_ISO2).reduce((acc, [alias, iso2]) => {
  const key = String(iso2 || "").toUpperCase();
  if (key) (acc[key] = acc[key] || []).push(alias);
  return acc;
}, {});

// Country search used by every country picker: name, ISO2, ISO3 and common abbreviations (UAE, UK, BVI, USA).
export function countryMatchesSearch(option, rawQuery) {
  const query = normalizeCountryLookupName(rawQuery);
  if (!query) return true;
  const iso2 = String(option?.value || "").toUpperCase();
  return [option?.label, iso2, toIso3(iso2), ...(COUNTRY_ALIASES_BY_ISO2[iso2] || [])]
    .map(normalizeCountryLookupName)
    .some((text) => text && text.includes(query));
}
